export const INVENTORY_TITLE_TYPES = {
    H1: 'h1',
    SEO: 'seo',
    META_TITLE: 'meta.title',
    META_DESCRIPTION: 'meta.description',
}
